var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31494 8.79695C2.31494 8.54126 2.52222 8.33398 2.7779 8.33398H40.7409C40.9966 8.33398 41.2038 8.54126 41.2038 8.79695V41.2044C41.2038 41.46 40.9966 41.6673 40.7409 41.6673H2.7779C2.52222 41.6673 2.31494 41.46 2.31494 41.2044V8.79695Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77778 6.01758H40.7407C42.2749 6.01758 43.5185 7.26123 43.5185 8.79536V41.2028C43.5185 42.7369 42.2749 43.9805 40.7407 43.9805H2.77778C1.24366 43.9805 0 42.7369 0 41.2028V8.79536C0 7.26123 1.24365 6.01758 2.77778 6.01758ZM2.77778 8.33239C2.52209 8.33239 2.31482 8.53967 2.31482 8.79536V41.2028C2.31482 41.4585 2.52209 41.6657 2.77778 41.6657H40.7407C40.9964 41.6657 41.2037 41.4585 41.2037 41.2028V8.79536C41.2037 8.53967 40.9964 8.33239 40.7407 8.33239H2.77778Z",
    fill: "#1F2D5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31494 16.666H41.2038V8.79565C41.2038 8.53996 40.9966 8.33268 40.7409 8.33268H2.7779C2.52222 8.33268 2.31494 8.53996 2.31494 8.79565V16.666Z",
    fill: "#3AC09D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2685 8.33398C11.6293 8.33398 11.1111 7.8158 11.1111 7.17658L11.1111 1.15806C11.1111 0.51884 11.6293 0.000651337 12.2685 0.000651309C12.9077 0.000651281 13.4259 0.51884 13.4259 1.15806L13.4259 7.17658C13.4259 7.8158 12.9077 8.33398 12.2685 8.33398Z",
    fill: "#1F2D5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4907 8.33398C33.8514 8.33398 33.3333 7.8158 33.3333 7.17658L33.3333 1.15806C33.3333 0.51884 33.8514 0.000651337 34.4907 0.000651309C35.1299 0.000651281 35.6481 0.51884 35.6481 1.15806L35.6481 7.17658C35.6481 7.8158 35.1299 8.33398 34.4907 8.33398Z",
    fill: "#1F2D5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2036 28.5775L19.9073 31.9445L27.3147 24.5371",
    stroke: "#3AC09D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9f3c0619.svg";
export { ForwardRef as ReactComponent };